// Angular
import {Component, EventEmitter, Input, Output} from '@angular/core';

// Afidium
import {
    IQuantity,
    ISegmentProperty,
    ISearchRequest
} from 'libraries/service/resources/hotel/ISearchParameters';
import {HelperService} from "libraries/hotel/services/helper.service";

import {Yii} from "libraries/interfaces/Yii";
import {GeopositionService} from 'libraries/service/geoposition/geoposition.service';
import {IAfiGeoposition} from 'libraries/service/geoposition/geoposition.model';
import {SearchHotelFormService} from 'libraries/hotel/containers/search-hotel-form/services/search-hotel-form.service';
import {IMinMax} from "libraries/interfaces/IMinMax";
import {ILabels} from "../../../interfaces/ILabels";

interface ITravellers {
    adult: {
        name: string;
        count: number;
    };
    child: {
        name: string;
        count: number;
    };
    infant: {
        name: string;
        count: number;
    };
    rooming: {
        pluralName?: string;
        name: string;
        count: number;
    };
}

@Component({
    selector: 'resume',
    templateUrl: './hotel-resume-search.component.html'
})
export class HotelResumeSearchComponent {
    @Input()
    public isGlobal?: boolean = false;

    @Input()
    public isUnitSearch?: boolean = false;

    @Input()
    public set resume(value: ISearchRequest) {
        if (value) {
            this.getTravellers(value.quantity);
        }
        this.resumeModel = value;
        this.initHosts();
    }

    public get resume(): ISearchRequest {
        return this.resumeModel;
    }

    @Output()
    public readonly onValidateCriteria?: EventEmitter<boolean> = new EventEmitter<boolean>();

    public isClicked: boolean = false;

    public travellers: ITravellers = {
        adult: {name: 'ADT', count: 1},
        child: {name: 'CHD', count: 0},
        infant: {name: 'INF', count: 0},
        rooming: {
            name: Yii.t('wui-shared-js', 'chambre'),
            pluralName: Yii.t('wui-shared-js', 'chambres'),
            count: 1
        }
    };

    public labels: { [key: string]: string } = {
        Meter: Yii.t('wui-shared-js', 'Mètres'),
        m: Yii.t('wui-shared-js', 'm.'),
        km: Yii.t('wui-shared-js', 'km.'),
        location: Yii.t('wui-shared-js', 'Lieu'),
        latitude: Yii.t('wui-shared-js', 'Latitude'),
        longitude: Yii.t('wui-shared-js', 'Longitude'),
        geoposition: Yii.t('wui-shared-js', 'Géoposition'),
        radius: Yii.t('wui-shared-js', 'Radius'),
        hosts: Yii.t('wui-shared-js', 'Fournisseurs'),
        night: Yii.t('wui-shared-js', 'nuit'),
        nights: Yii.t('wui-shared-js', 'nuits'),
        all: Yii.t('wui-shared-js', 'Tous'),
        standardisationBody: Yii.t('wui-shared-js', 'Standard'),
        traveller: Yii.t('wui-shared-js', 'Voyageur'),
        brand: Yii.t('wui-shared-js', 'Marque'),
        noRequestText: Yii.t('wui-shared-js', 'Merci de valider les critères de recherche'),
    };

    public hasAllHosts: boolean = false;

    public nbHosts: number;
    public hostsList: string;

    public dateFormat: { [key: string]: string };
    private resumeModel: ISearchRequest;

    constructor(
        private readonly searchHotelFormService: SearchHotelFormService,
        private readonly helperService: HelperService,
        private readonly geopositionService: GeopositionService,
    ) {
        this.dateFormat = this.helperService.getDateFormat();
    }


    /**
     * initHosts
     *
     * set Hosts datas to display:
     */
    public initHosts(): void {
        if (this.resumeModel &&
            this.resumeModel.segment && this.resumeModel.segment[0].property &&
            this.resumeModel.segment[0].property.host) {
            //for now, in only have 1 segment
            const property: ISegmentProperty = this.resumeModel.segment[0].property;
            this.searchHotelFormService.getFormHotelData()
                .subscribe((config: { hosts: string[] }) => {
                    this.nbHosts = config.hosts.length;
                    this.hostsList = "";
                    let i: number = 1;
                    property.host.forEach((host: string) => {
                        this.hostsList += i !== property.host.length ? `${host} ,` : host;
                        i++;
                    });
                    if (config.hosts.length && property.host.length === config.hosts.length) {
                        // do sort only if same length
                        const hostConfig: string[] = config.hosts.sort();
                        const hostResume: string[] = property.host.sort();
                        this.hasAllHosts = hostConfig === hostResume;
                    }
                });
        }
    }

    public hasGeoPosition(geoposition: IAfiGeoposition): boolean {
        return !this.geopositionService.isEmpty(geoposition);
    }

    public isRating(rating: IMinMax): boolean {
        return (rating && rating.min !== undefined && rating.min !== 0 && rating.max !== undefined);
    }

    private getTravellers(quantity: IQuantity): void {
        if (quantity) {
            this.travellers.adult.count = quantity.adult;
            this.travellers.child.count = quantity.child;
            this.travellers.infant.count = quantity.infant;
            this.travellers.rooming.count = quantity.rooming;
        }
    }

    public toValidate(): void {
        this.isClicked = true;
        this.onValidateCriteria.emit(this.isClicked);
    }
}
